export default __webpack_public_path__ + "static/media/swiper-paginate-outer-right.3764e6f4.png";